import React, { useEffect, useState } from 'react';

import { convertSnakeToTitleCase } from '../../utils/StringUtils';

const PreferenceGroup = ({ title, values, editMode, onToggle }) => {
    const activeEntries = Object.entries(values || {}).filter(
        ([, status]) => status
    );

    return (
        <div className="investor-info-group">
            <h5>{title}</h5>
            {editMode ? (
                <div className="profile-toggle-grid">
                    {Object.entries(values || {}).map(([type, status]) => (
                        <label className="profile-toggle" key={type}>
                            <input
                                type="checkbox"
                                checked={Boolean(status)}
                                onChange={() => onToggle(type, !status)}
                            />
                            <span>{convertSnakeToTitleCase(type)}</span>
                        </label>
                    ))}
                </div>
            ) : (
                <div className="profile-chip-list">
                    {activeEntries.length ? (
                        activeEntries.map(([type]) => (
                            <span className="profile-chip" key={type}>
                                {convertSnakeToTitleCase(type)}
                            </span>
                        ))
                    ) : (
                        <p className="profile-muted">No selections yet.</p>
                    )}
                </div>
            )}
        </div>
    );
};

const InvestorInfo = ({
    classes,
    strategies,
    handleProfileEdit,
    isLoggedInUser,
}) => {
    const [editMode, setEditMode] = useState(false);
    const [classState, setClassState] = useState(classes || {});
    const [strategyState, setStrategyState] = useState(strategies || {});
    const [error, setError] = useState('');

    useEffect(() => {
        setClassState(classes || {});
        setStrategyState(strategies || {});
    }, [classes, strategies]);

    const handleCancelEdit = () => {
        setEditMode(false);
        setClassState(classes || {});
        setStrategyState(strategies || {});
        setError('');
    };

    const handleSave = async () => {
        setError('');
        try {
            await handleProfileEdit({
                classes: classState,
                strategies: strategyState,
            });
            setEditMode(false);
        } catch (err) {
            setError(err.response?.data?.detail || 'Unable to save changes.');
        }
    };

    return (
        <section className="profile-card investor-info">
            <div className="profile-card-header">
                <div>
                    <p className="profile-card-kicker">Interests</p>
                    <h4>Investor Interests</h4>
                </div>
                {isLoggedInUser && !editMode && (
                    <button
                        className="profile-icon-button"
                        type="button"
                        aria-label="Edit investor interests"
                        onClick={() => setEditMode(true)}
                    >
                        <i className="bi-pencil-square" />
                    </button>
                )}
            </div>
            <div className="investor-info-columns">
                <PreferenceGroup
                    title="Asset Classes"
                    values={classState}
                    editMode={editMode}
                    onToggle={(type, value) =>
                        setClassState({ ...classState, [type]: value })
                    }
                />
                <PreferenceGroup
                    title="Strategies"
                    values={strategyState}
                    editMode={editMode}
                    onToggle={(type, value) =>
                        setStrategyState({ ...strategyState, [type]: value })
                    }
                />
            </div>
            {editMode && (
                <div className="profile-action-row">
                    <button
                        className="btn profile-secondary-button"
                        type="button"
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn profile-primary-button"
                        type="button"
                        onClick={handleSave}
                    >
                        Save
                    </button>
                </div>
            )}
            {error && <p className="profile-inline-error">{error}</p>}
        </section>
    );
};

export default InvestorInfo;
